import React from 'react';
import { motion, HTMLMotionProps, AnimatePresence } from 'framer-motion';

interface ToasterProps {
  toast: {
    title: string;
    description: string;
  } | null;
}

type MotionDivProps = HTMLMotionProps<"div"> & {
  className?: string;
};

const MotionDiv = motion.div as React.FC<MotionDivProps>;

export const Toaster: React.FC<ToasterProps> = ({ toast }) => {
  return (
    <AnimatePresence>
      {toast && (
        <MotionDiv
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.95 }}
          transition={{ type: "spring", stiffness: 400, damping: 30 }}
          className="fixed bottom-4 right-4 bg-white p-4 rounded-lg shadow-lg z-50"
        >
          <h4 className="font-semibold">{toast.title}</h4>
          <p className="text-sm text-gray-600">{toast.description}</p>
        </MotionDiv>
      )}
    </AnimatePresence>
  );
}; 